import type { Breadcrumb } from "@sentry/react";

// Sentry attaches recent activity to every error it sends. Receipts hold health and spending
// details, so keep only what's needed to debug: the label of a console call, not what was
// logged with it, and not the filenames and signed tokens in storage URLs.
export function scrubBreadcrumb(breadcrumb: Breadcrumb): Breadcrumb {
  if (breadcrumb.category === "console") {
    const label = breadcrumb.data?.arguments?.[0];
    return {
      ...breadcrumb,
      message: typeof label === "string" ? label : undefined,
      data: undefined,
    };
  }

  const isRequest = breadcrumb.category === "fetch" || breadcrumb.category === "xhr";
  if (isRequest && typeof breadcrumb.data?.url === "string") {
    return {
      ...breadcrumb,
      data: {
        ...breadcrumb.data,
        url: breadcrumb.data.url.replace(/(\/storage\/v1\/object\/).*/, "$1[removed]"),
      },
    };
  }

  return breadcrumb;
}
